<template>
  <div class="page-activity-manage">

    <div class="com-list-header">

      <el-form  @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" placeholder="输入关键字检索" prop="filename">
              <el-input v-model="form.filename"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-upload action="/singleMuseum/repair/StandardQuery/upload" :show-file-list="false" :on-success="handleSuccess">
            <el-button class="el-primary-border">
              <svg-icon icon-class="add" />&nbsp;上传
            </el-button>
          </el-upload>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="attName" label="文件名称" min-width="20%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fileType" label="文档类型" min-width="11%"></el-table-column>
          <el-table-column prop="attDate" label="最后上传时间" min-width="10%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.attDate, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="上传人" min-width="10%" show-overflow-tooltip></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="preview(scope.row)">预览</a>
              <a class="m-btn mr-10" @click="download(scope.row)">下载</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      form: {
        filename: '',
      },
      typeList: [],
      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.tableData = []
      this.$http
        .get('/repair/StandardQuery/pageList', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.initList()
      } else {
        this.$message.error(res.message)

      }
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    preview(item) {
      window.open('/singleMuseum/repair/bsRepairSpecification/view?id=' + item.attId + '&edit=false&userId=admin&userName=admin', '_blank')

      // this.$http
      //   .get('/repair/bsRepairSpecification/view', {
      //     url: item.attId,
      //   }).then(res => {
      //     if (res.success) {
      //       location.href =
      //         '/singleMuseum/repair/StandardQuery/onlinePreview?url=' + item.attId
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },

    download(item) {
      location.href =
        '/singleMuseum/repair/StandardQuery/download?attachmentId=' + item.attId
    },

    handleDelete(item) {
      this.$common.confirm(
        {
          title: '是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http.get('/repair/StandardQuery/delete', {
            filedId: item.attId
          }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}
</style>